import { render, staticRenderFns } from "./MotivoCancelacion.vue?vue&type=template&id=5282b690"
import script from "./MotivoCancelacion.vue?vue&type=script&lang=js"
export * from "./MotivoCancelacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports